import { createFileRoute } from '@tanstack/react-router';
import { CustomFieldsSettingsPage } from 'src/modules/settings/components/pages/custom-fields-settings.page';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';

export const Route = createFileRoute('/settings/custom-fields')({
  component: CustomFieldsSettingsPage,
  validateSearch: (search) => settingsSearchSchema.parse(search),
});
